import React, { FunctionComponent } from 'react';
import { IconButton, InputAdornment, InputBaseComponentProps, TextField } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import ReactInputMask from 'react-input-mask';

interface UnprotectedFieldProps {
  disabled: boolean;
  textFieldProps: any;
  error: boolean;
  helperText: string;
  value: string;
  onBlur: () => void;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  mask: string;
  endAdornment: boolean;
  isVisible: boolean;
  eyeballHandler: () => void;
  dataTestId?: string;
}

export const UnprotectedField = ({
  disabled,
  textFieldProps,
  error,
  helperText,
  value,
  onBlur,
  label,
  onChange,
  mask,
  endAdornment,
  isVisible,
  eyeballHandler,
  dataTestId,
}: UnprotectedFieldProps) => {
  return (
    <TextField
      fullWidth
      disabled={disabled}
      {...textFieldProps}
      error={error}
      helperText={helperText}
      value={value}
      onBlur={onBlur}
      label={label}
      onChange={onChange}
      InputProps={{
        inputComponent: (ReactInputMask as unknown) as FunctionComponent<InputBaseComponentProps>,
        inputProps: {
          inputcomponent: ReactInputMask,
          mask,
          ref: textFieldProps.ref,
          'data-testid': dataTestId,
        },
        endAdornment: endAdornment ? (
          <InputAdornment position="end" tabIndex={-1}>
            <IconButton
              size="small"
              tabIndex={-1}
              disabled={value === '' || error || disabled}
              onMouseDown={(event) => {
                event.preventDefault();
                eyeballHandler();
              }}
            >
              {!isVisible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};
